// extracted by mini-css-extract-plugin
export var card = "_kn-0";
export var content = "_kn-2";
export var details = "_kn-3";
export var icon = "_kn-1";
export var iconBlue = "_kn-5";
export var iconBrand = "_kn-4";
export var iconGrayBlue = "_kn-6";
export var iconGreen = "_kn-7";
export var iconIndigo = "_kn-8";
export var iconOrange = "_kn-9";
export var iconPurple = "_kn-a";
export var iconRed = "_kn-b";
export var iconWarning = "_kn-c";